import {
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnInit,
  output,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { BaseComponent } from '@app/components/base/base.component';
import { OpenQuoteService } from '@app/pages/quote/open-quote/services/open-quote-service.service';
import { AuthService } from '@app/common/auth.service';
import { ModalService } from '@app/components/modal/modal.service';
import { quoteEnum } from '@app/components/grace-special-payments/quote-enum.model';
import { NotificationService } from '@app/services/notifications.service';
import { MenusServices } from '@app/services/menus.service';
import { ActivatedRoute } from '@angular/router';
import { ResponsiveService } from '@app/services/responsive.service';

@Component({
  selector: 'app-deals',
  templateUrl: './deals.component.html',
  styleUrls: ['./deals.component.scss'],
})
export class DealsComponent extends BaseComponent implements OnInit {
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  @ViewChild('addNewProposalBtn') addNewProposalBtnRef?: ElementRef<HTMLButtonElement>;
  @ViewChild('addNewProposalBtnBottom') addNewProposalBtnBottomRef?: ElementRef<HTMLButtonElement>;
  @Output() createDraft: EventEmitter<any> = new EventEmitter();
  @Output() changeModeEdition: EventEmitter<any> = new EventEmitter();
  readonly selectedDealEvent = output<void>();
  @Input() customer: any;
  @Input() proposals: any;
  @Input() isModeEdition: boolean;
  /** COMPLETED/APPROVED: no crear/editar/eliminar propuestas. */
  @Input() proposalsReadOnly = false;
  @Input() idQuote: any;
  nameCompany = input('');
  @Input() isValid: boolean;
  @Input() userId: any;
  @Input() financialService: any;
  @Input() quoteType: quoteEnum;
  formGroupArray: any[] = [];

  index: number;
  insuranceEdit: boolean = false;
  isLoading: boolean = false;

  selectedDeal: any;
  selectedInsurance: any;

  showDealForm: boolean = false;
  showInsunranceForm: boolean = false;
  indexDeal: any = -1;
  indexInsurance: any = -1;

  idDeal: number;
  indexDealDelete: number | null;
  indexInsuranceDelete: number;
  title: string = 'Eliminar cotización';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  readonly responsive = inject(ResponsiveService);

  constructor(
    public fb: FormBuilder,
    private quoteService: OpenQuoteService,
    public financialCalculator: FinancialCalculatorService,
    public authService: AuthService,
    private modalService: ModalService,
    notification: NotificationService,
    menuService: MenusServices,
    route: ActivatedRoute
  ) {
    super(route, menuService, notification);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['proposals']) {
      this.formGroupArray = this.proposals;
      this.selectedDeal = this.formGroupArray[this.indexDeal];
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  ngOnInit() {
    this.responsive.onListen();
  }

  focusAddProposalButton() {
    try {
      if (!this.isModeEdition && !this.proposalsReadOnly && this.addNewProposalBtnRef) {
        this.addNewProposalBtnRef.nativeElement.focus();
      }
    } catch {}
  }

  handleTopButtonKeydown(event: KeyboardEvent) {
    if (event.key === 'Tab' && !event.shiftKey) {
      const target = event.target as HTMLButtonElement;
      // If top button is focused and bottom exists, skip deals
      if (this.addNewProposalBtnBottomRef && target === this.addNewProposalBtnRef?.nativeElement) {
        event.preventDefault();
        this.addNewProposalBtnBottomRef.nativeElement.focus();
      }
    }
  }

  //#region DEAL
  addNewProposal() {
    if (this.proposalsReadOnly) {
      return;
    }
    this.selectedDeal = undefined;
    this.isModeEdition = true;
    this.changeModeEdition.emit(true);
  }
  duplicateProposal(deal: any) {
    const dealDuplicate = {
      ...deal,
      id: null,
      creationDate: null,
      profitDeal: null,
      insuranceDeals: [],
      result: {
        ...deal.result,
        id: null,
        creationDate: null,
      },
      payments: this.getPayments(deal.payments),
      specialPayments: this.getSpecialPayments(deal.specialPayments),
      grace: this.getGrace(deal.grace),
      irregularPayments: this.getIrregularPayments(deal.irregularPayments),
      roRac: null,
      insurance: deal.insurance !== null ? {
        ...deal.insurance,
        creationDate: null,
        updatedDate: null,
        packageList: null,
        insuranceId: null,
        requestId: null,
        creationUser: null,
        updateUser: null,
        openQuoteInsurancePayments: null,
      } : null,
      openQuoteBrand: deal.openQuoteBrand ? {
        ...deal.openQuoteBrand,
        id: null,
      } : null,
      openQuoteSubBrand: deal.openQuoteSubBrand ? {
        ...deal.openQuoteSubBrand,
        id: null,
      } : null,
      openQuoteModel: deal.openQuoteModel ? {
        ...deal.openQuoteModel,
        id: null,
      } : null,
    };
    dealDuplicate.isSelected = false;

    this.selectedDeal = dealDuplicate;

    this.indexDeal = -1;
    this.isModeEdition = true;
    this.changeModeEdition.emit(true);
  }

  getIrregularPayments(irregularPayments: any) {
    if (!irregularPayments) return null;
    return irregularPayments.map((payment: any) => {
      return { ...payment, id: null, creationDate: null, updatedDate: null };
    });
  }

  getPayments(payments: any) {
    if (!payments) return null;
    return payments.map((payment: any) => {
      return { ...payment, id: null, creationDate: null, updatedDate: null };
    });
  }

  getSpecialPayments(specialPayments: any) {
    if (!specialPayments) return null;
    return specialPayments.map((payment: any) => {
      return { ...payment, id: null, creationDate: null, updatedDate: null };
    });
  }

  getGrace(grace: any) {
    if (!grace) return null;
    return grace.map((grace: any) => {
      return { ...grace, id: null, creationDate: null, updatedDate: null };
    });
  }

  delete() {
    if (this.indexInsuranceDelete != null) {
      this.deleteInsurance();
    } else if (
      this.indexDealDelete != null &&
      this.indexInsuranceDelete == null
    ) {
      this.deleteDeal();
    }
  }

  deleteDeal(): void {
    if (this.indexDealDelete == null) return;
    const deal = this.formGroupArray[this.indexDealDelete];
    const { id } = deal;

    this.isLoading = true;
    if (id != null) {
      this.closeModal();
      this.quoteService.deleteProposal(this.idQuote, id).subscribe({
        next: () => {
          this.isLoading = false;
          this.closeModal();
          //INFO: Implementacion no optima, pero quita el problema
          /* Se debe actualizar el listado de deals activas,
           * evitando que el createDraft las genere nuevamente
           */
          window.location.reload();
        },
      });
    } else {
      this.formGroupArray.splice(this.index, 1);
      this.createDraft.emit(this.formGroupArray);
    }
  }

  deleteInsurance(): void {
    if (this.indexDealDelete == null && this.indexInsuranceDelete == null)
      return;
    if (this.indexDealDelete == null) return;
    const insurance =
      this.formGroupArray[this.indexDealDelete].insuranceDeals[
        this.indexInsuranceDelete
      ];
    const idInsurance = insurance.id;

    this.isLoading = true;
    if (idInsurance != null) {
      this.closeModal();
      this.quoteService
        .deleteInsuranceOpen(this.idQuote, this.idDeal, idInsurance)
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            if (
              this.indexDealDelete == null ||
              this.indexInsuranceDelete == null
            )
              return;
            this.formGroupArray[this.indexDealDelete].insuranceDeals.splice(
              this.indexInsuranceDelete,
              1
            );
            this.indexDeal = null;
            this.indexInsurance = null;
            this.createDraft.emit(this.formGroupArray);
          },
          error: (error) => {
            this.isLoading = true;
          },
        });
    } else {
      if (this.indexDealDelete == null || this.indexInsuranceDelete == null)
        return;

      this.formGroupArray[this.indexDealDelete].insuranceDeals.splice(
        this.indexInsuranceDelete,
        1
      );
      this.createDraft.emit(this.formGroupArray);
    }
  }

  updateDeals(deal: any) {
    if (this.indexDeal >= 0) {
      this.formGroupArray[this.indexDeal] = deal;
    } else {
      this.formGroupArray.push(deal);
      this.indexDeal = this.formGroupArray.length - 1;
    }
    this.createDraft.emit(this.formGroupArray);
  }

  changeMode(index: number) {
    //Levantar edicion
    this.indexDeal = index;
    const selectedDeal = this.formGroupArray[index];
    this.selectedDeal = selectedDeal;
    this.isModeEdition = !this.isModeEdition;
    this.changeModeEdition.emit();
    this.index = index;
  }

  closeEditionDeal(e: any) {
    //Cerrar edicion
    this.changeModeEdition.emit();
    this.isModeEdition = !this.isModeEdition;
    this.showDealForm = !this.showDealForm;
    this.selectedDeal = {};
    this.indexDeal = -1;
  }

  //#endregion DEAL

  //#region INSURANCE
  addInsurance(indexInsurance: number, indexDeal: number) {
    this.selectedDeal = this.formGroupArray[indexDeal];
    this.indexDeal = indexDeal;
    this.indexInsurance = indexInsurance;
    this.showInsunranceForm = !this.showInsunranceForm;
    this.changeModeEdition.emit();
  }

  changeModeInsurance(indexInsurance: number, index: number) {
    //Levanrtar edicion
    this.indexDeal = index;
    this.indexInsurance = indexInsurance;
    this.selectedDeal = this.formGroupArray[index];
    this.selectedInsurance = this.selectedDeal[index];
    this.showInsunranceForm = !this.showInsunranceForm;
    this.changeModeEdition.emit();
  }

  updateInsurance(insurance: any) {
    if (this.indexInsurance >= 0) {
      this.formGroupArray[this.indexDeal].insuranceDeals[this.indexInsurance] =
        insurance;
    } else {
      this.formGroupArray[this.indexDeal].insuranceDeals.push(insurance);
      this.indexInsurance =
        this.formGroupArray[this.indexDeal].insuranceDeals.length - 1;
    }
    this.createDraft.emit(this.formGroupArray);
  }

  closeEditionInsurance(e: any) {
    //Cerrar edicion
    this.changeModeEdition.emit();
    this.isModeEdition = !this.isModeEdition;
    this.showInsunranceForm = !this.showInsunranceForm;
    this.indexInsurance = -1;
    this.indexDeal = -1;
    this.selectedDeal = {};
  }

  //#endregion INSURANCE

  isSelected(indexInsurance: number, index: number) {
    if (indexInsurance != null) {
      const isSelected =
        this.formGroupArray[index].insuranceDeals[indexInsurance].isSelected;
      this.formGroupArray[index].insuranceDeals[indexInsurance].isSelected =
        !isSelected;
    } else {
      const isSelected = this.formGroupArray[index].isSelected;
      this.formGroupArray[index].isSelected = !isSelected;
      if (this.formGroupArray[index].insuranceDeals.length != 0) {
        this.formGroupArray[index].insuranceDeals = this.formGroupArray[
          index
        ].insuranceDeals.map((i: any) => {
          return { ...i, isSelected: !isSelected };
        });
      }
    }
    this.createDraft.emit(this.formGroupArray);
  }

  selectDeal(event: any, index: number) {
    if (this.proposalsReadOnly) {
      event?.preventDefault?.();
      return;
    }
    const selectedDealsCount = this.formGroupArray.filter(
      (item: any) => item.isSelected
    ).length;
    if (event.target.checked && selectedDealsCount >= 6) {
      this.showNotificationError(
        'Ha excedido el número máximo de propuestas permitidas.'
      );
      event.preventDefault();
      return;
    }
    const isSelected = this.formGroupArray[index].isSelected;
    this.formGroupArray[index].isSelected = !isSelected;
    // this.createDraft.emit(this.formGroupArray);
    this.selectedDealEvent.emit();
  }

  selectedInsuranceEvent(event: any, index: number) {
    if (this.proposalsReadOnly) {
      event?.event?.preventDefault?.();
      return;
    }
    const idInsurance = event.index;
    const selectedDeals = this.formGroupArray.filter(
      (item: any) => item.isSelected
    );
    const selectedDealsCount = selectedDeals.length;
    const isSelected = this.formGroupArray[index]?.insuranceDeals?.[idInsurance]?.isSelected;

    if (isSelected && selectedDealsCount >= 6) {
      this.showNotificationError(
        'Ha excedido el número máximo de propuestas permitidas.'
      );
      event.event?.preventDefault?.();
      return;
    }
    this.formGroupArray[index].insuranceDeals[idInsurance].isSelected = !isSelected;
    // this.createDraft.emit(this.formGroupArray);
    this.selectedDealEvent.emit();
  }

  openModalConfirmationDeal(indexDeal: any) {
    this.indexDealDelete = indexDeal;
    const deal = this.formGroupArray[indexDeal];
    this.idDeal = deal.id;
    this.subtitle = `¿Confirma la eliminación de la cotización "${deal.dealName}"?`;
    this.modalService.component = this.template;
    this.modalService.openModal();
  }

  openModalConfirmationInsurance(indexInsurance: any, indexDeal: any) {
    this.indexInsuranceDelete = indexInsurance;
    this.indexDealDelete = indexDeal;
    const deal = this.formGroupArray[indexDeal];
    this.idDeal = deal.id;
    this.subtitle = `¿Confirma la eliminación del seguro "${deal.insuranceDeals[indexInsurance].dealName}"?`;
    this.modalService.component = this.template;
    this.modalService.openModal();
  }

  showBtn() {
    if (this.idQuote) {
      if (this.userId != this.authService.currentUserIds) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }


}
